import { render, staticRenderFns } from "./moveAppointmentDialog.vue?vue&type=template&id=d81639c2&"
import script from "./moveAppointmentDialog.vue?vue&type=script&lang=js&"
export * from "./moveAppointmentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports